import { useState } from "react";
import { useGetExpenseDepartments } from "../../../../hooks/api/queries/useExpenses";
import { useUrlSearch } from "../../../../hooks/useUrlSearch";

const useExpenseDepartments = () => {
  const { queries, gotoPage } = useUrlSearch();
  const [isCreateDepartment, setIsCreateDepartment] = useState(false);

  const { isLoading: isFetchingDepartments, data } = useGetExpenseDepartments({
    queries,
  });

  return {
    isFetchingDepartments,
    expenseDepartments: data?.data || [],
    metaDetails: data?.meta,
    isCreateDepartment,
    setIsCreateDepartment,
    gotoPage,
  };
};

export default useExpenseDepartments;
